import styled from 'styled-components';
import { Box } from '@rsos/components/capstone/base';

export const TagContainer = styled(Box).attrs({
  height: 16,
  px: '5px',
  mr: 'auto',
})`
  border: 1px solid ${({ theme }) => theme.colors.primaryBase};
  border-radius: 5px;
`;
